import { render, staticRenderFns } from "./RejectInfo.vue?vue&type=template&id=36a40639"
import script from "./RejectInfo.vue?vue&type=script&lang=js"
export * from "./RejectInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports